export enum ClientApps {
  Ignite = 'Ignite',
  ClubHub = 'ClubHub',
  LenderHub = 'LenderHub',
  UserManager = 'UserManager',
}
